import { DataTexture } from './DataTexture';

export abstract class AnimationDataTexture extends DataTexture {
  public abstract getFrameOffset(clipId: string, frameIndex: number): number;
}
